import React from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioOverview = ({ portfolioData }) => {
  const { totalValue, todayChange, todayChangePercent, unrealizedGain, unrealizedGainPercent } = portfolioData;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {/* Total Portfolio Value */}
      <div className="card-elevated p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-muted-foreground">Total Portfolio Value</h3>
          <Icon name="DollarSign" size={20} className="text-primary" />
        </div>
        <div className="space-y-1">
                  <p className="text-2xl font-bold text-foreground">₹{totalValue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</p>
        <div className={`flex items-center space-x-1 text-sm ${todayChange >= 0 ? 'text-success' : 'text-destructive'}`}>
          <Icon name={todayChange >= 0 ? "TrendingUp" : "TrendingDown"} size={16} />
          <span className="font-mono">₹{Math.abs(todayChange).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
            <span className="font-mono">({todayChangePercent >= 0 ? '+' : ''}{todayChangePercent.toFixed(2)}%)</span>
          </div>
        </div>
      </div>

      {/* Unrealized Gains/Losses */}
      <div className="card-elevated p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-muted-foreground">Unrealized Gains/Losses</h3>
          <Icon name="TrendingUp" size={20} className={unrealizedGain >= 0 ? 'text-success' : 'text-destructive'} />
        </div>
        <div className="space-y-1">
                  <p className={`text-2xl font-bold ${unrealizedGain >= 0 ? 'text-success' : 'text-destructive'}`}>
          {unrealizedGain >= 0 ? '+' : ''}₹{unrealizedGain.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </p>
          <div className={`flex items-center space-x-1 text-sm ${unrealizedGain >= 0 ? 'text-success' : 'text-destructive'}`}>
            <span className="font-mono">({unrealizedGainPercent >= 0 ? '+' : ''}{unrealizedGainPercent.toFixed(2)}%)</span>
            <span className="text-muted-foreground">vs. cost basis</span>
          </div>
        </div>
      </div>

      {/* Performance Indicator */}
      <div className="card-elevated p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-muted-foreground">Performance vs S&P 500</h3>
          <Icon name="BarChart3" size={20} className="text-primary" />
        </div>
        <div className="space-y-1">
          <p className="text-2xl font-bold text-success">+2.4%</p>
          <div className="flex items-center space-x-1 text-sm text-muted-foreground">
            <span>Outperforming by</span>
            <span className="font-mono text-success">+0.8%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioOverview;